// Pacchetti Target Training nel checkout (devops #212, slice S4).
//
// Logica pura, senza Vue: la scelta del pacchetto, il prezzo e la voce di riepilogo passano da qui così
// si provano senza browser (src/utils/targetPack.test.mjs). Con l'iniziativa spenta l'API risponde
// `packs: []` e ogni funzione ricade sul comportamento di sempre: il checkout resta identico.

/** Pacchetti proponibili dalla risposta di GET /api/open/target-training-packs. */
export function packsFromResponse(body) {
    const packs = Array.isArray(body?.packs) ? body.packs : [];
    return packs.filter(p => p && p.code && Number(p.price) > 0);
}

/** Variazione del prodotto Target che porta il `packCode` (l'ordine si crea con il suo variationName). */
export function variationForPack(product, code) {
    const vars = Array.isArray(product?.variations) ? product.variations : [];
    return vars.find(v => v?.attributes?.packCode === code && v.active !== false) || null;
}

/** Solo i pacchetti ordinabili: un codice senza variazione corrispondente non si può comprare, quindi non si mostra. */
export function orderablePacks(packs, product) {
    return (packs || []).filter(p => variationForPack(product, p.code));
}

export function findPack(packs, code) {
    if (!code) return null;
    return (packs || []).find(p => p.code === code) || null;
}

/** Il codice scelto resta valido solo se il nuovo elenco lo contiene ancora (cambio trainer = cambio fascia). */
export function keepSelection(packs, code) {
    return findPack(packs, code) ? code : null;
}

/** Prezzo pieno della voce Target: quello del pacchetto scelto, altrimenti il prezzo del prodotto. */
export function targetBasePrice(pack, productPrice) {
    return pack ? Number(pack.price) : (productPrice || 0);
}

/** Etichetta della riga nel riepilogo ordine: voce separata e leggibile per il pacchetto. */
export function summaryLabel(pack) {
    return pack ? `Target Training – ${pack.label}:` : 'Target Training:';
}

/** `additionals` dell'ordine per l'upsell Target: con un pacchetto si aggiunge la variazione col packCode. */
export function targetAdditionals(trainerId, pack, product) {
    const additionals = { targetTrainerId: trainerId };
    const variation = pack ? variationForPack(product, pack.code) : null;
    if (variation) additionals.variationName = variation.variationName;
    return additionals;
}
